import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <div className="project-card-img-container">
        <Card.Img
          variant="top"
          src={props.imgPath}
          alt="card-img"
          style={{
            height: props.h,
            width: props.w,
            marginLeft: props.m,
          }}
        />
      </div>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>
          {props.description}
        </Card.Text>
        <Button variant="primary" href={props.ghLink} target="_blank">
          {props.isBlog ? <BsGithub /> : <CgWebsite />}
          &nbsp;
          {props.isBlog ? "GitHub" : "Website"}
        </Button>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
